module.exports = __webpack_public_path__ + "img/metrics.bc80afe1.jpeg";